import React, { createContext, useState, useMemo, } from 'react';
var HeaderContext = createContext(undefined);
function HeaderProvider(_a) {
    var children = _a.children;
    var _b = useState([]), headers = _b[0], setHeaders = _b[1];
    var contextValue = useMemo(function () { return ({ headers: headers, setHeaders: setHeaders }); }, [headers]);
    return (React.createElement(HeaderContext.Provider, { value: contextValue }, children));
}
export { HeaderProvider, HeaderContext };
